import React, { Component, ErrorInfo, ReactNode } from "react";
import { Container } from "@material-ui/core";
import { AppBar, Box, Toolbar } from "@material-ui/core";

import { SrTitle, SrMainLogo, SrButton } from "..";
import { trackError } from "utils/tracker";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

const ErrorPage = () => {
  return (
    <Container>
      <AppBar color="primary" position="fixed" elevation={0}>
        <Toolbar>
          <SrMainLogo />
        </Toolbar>
      </AppBar>
      <Box
        height="100vh"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Box textAlign="center" mt={2} mb={2}>
          <SrTitle>Lo sentimos, ha ocurrido un error</SrTitle>
        </Box>
        <SrButton href="/" variant="contained">
          Recargar página
        </SrButton>
      </Box>
    </Container>
  );
};

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    trackError(error);
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
